<div
  class="fixed right-0 top-1/2 -translate-y-1/2 z-1000 flex flex-col items-center"
>
  <button
    class="relative group w-[32px] h-[96px] flex items-center justify-center transition-all duration-300 hover:-translate-x-1 cursor-pointer border-none bg-transparent"
    (click)="toggleMenu()"
    [matTooltip]="'openWidgetMenu' | translate"
    matTooltipPosition="left"
  >
    <svg
      width="32"
      height="96"
      viewBox="0 0 24 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute inset-0 pointer-events-none drop-shadow-prominent"
    >
      <path
        d="M0 21.5C0 19.2967 1.03736 17.222 2.8 15.9L24 0V72L2.87579 56.5969C1.06868 55.2792 0 53.1774 0 50.9409V21.5Z"
        fill="white"
      />
    </svg>
    <ic-chevron-down
      [startColor]="'var(--color-primary-start-color)'"
      [endColor]="'var(--color-primary-end-color)'"
      [width]="20"
      [height]="20"
      [rotate]="90"
      class="z-10 group-hover:scale-110 transition-transform duration-500"
    ></ic-chevron-down>
  </button>
</div>
